import React, { useEffect, useRef } from "react";
import { useState } from "react";
import Message from "../../Modal/Message";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import building from "../../Assets/buildings.png";
import pickupicon from "../../Assets/pickupicon.png";
import dropicon from "../../Assets/drop-icon.png";
import user from "../../Assets/user.png";
import threedots from "../../Assets/route_3dots.png";
import startLocation from "../../Assets/start_location.png";
import TickmarkImage from "../../Assets/Tickmark.png";
import addStopIcon from "../../Assets/addStopIcon.png";
import ErrorImage from "../../Assets/Error.png";
import useHttp from "../../Hooks/use-http";
import "./PrivateDriverBooking.css";
import { toast } from "react-toastify";
import { littleGreen } from "../CommonComponent/DefineColors";

let autocomplete = [];
let url;
let requestOptions = {};
let requestTripId = "";
let myHeaders = "";
let riderInfo = {};
let authToken = "";
let error = {
  riderName: "",
  pickupStop: "",
  dropStop: "",
  guestName: "",
  guestMoNumber: "",
};
let str = [];
let pickupDrop = [];
let dropOffs = [];
let arr = [];
arr.length = 8;
arr.fill(0, 0, 8);
// let baseURL =
//   window.location.origin === "https://corp.little.global"
//     ? "https://corp.little.global/server"
//     : "";

// let baseURL = "http://localhost:4001";
// let baseURL = "http://192.168.106:4001";

// let baseURL = "http://52.183.138.214:4001";
let baseURL = "https://littleinfinity.in:4001";

const PrivateDriverBooking = (props) => {
  const [isDriverBookingClicked, setIsDriverBookingClicked] = useState(false);
  const [isToken, setIsToken] = useState("");
  const [searchedRidersData, setIsSearchedRidersData] = useState(false);
  const [isRequestSentToDriver, setIsRequestSentToDriver] = useState(false);
  const [tripRequestStatus, setTripRequestStatus] = useState(null);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [isRender, setIsRender] = useState(false);
  const [riderData, setRiderData] = useState([]);
  const [isFieldError, setIsFieldError] = useState(false);
  const [addStopCount, setAddStopCount] = useState(0);
  const riderInputSearchRef = useRef();
  const pickupInputRef = useRef();
  const dropInputRef = useRef();
  const guestNameInputRef = useRef();
  const guestMoNumberInputRef = useRef();
  let timer = "30";

  function paraMeters() {
    if (isDriverBookingClicked) {
      // url = "/map/service/ride/book";
      url = "/privatebooking";

      myHeaders = {
        "Content-Type": "application/json",
        // Authorization: "Bearer " + isToken,
      };
      requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({
          // type: "CORPORATE",
          driver: props.bookedDriver[0].driverEmail,
          rider: {
            mobileNumber: riderInfo.mobileNumber,
            // mobileNumber: riderInfo.mobileNumber,

            name: riderInfo.name,
            // email: localStorage.getItem("user"),
            // picture: "https://google.com/mypicture.com",
          },

          vehicleType: props.bookedDriver[0].carType,
          pickUp: {
            // latlng: "22.9929777,72.5013096",
            latlng: pickupDrop[0]?.latLng,
            address: pickupDrop[0]?.address,
          },
          dropOff: {
            // latlng: "22.9929777,72.5013096",
            latlng: pickupDrop[1]?.latLng,
            address: pickupDrop[1]?.address,
          },
          timer,
          // dropOffs,
          // corporate: {
          //   // corporateId: localStorage.getItem("corpId"),
          //   corporateId: props?.bookedDriver[0]?.activeShiftCorporateId

          // },
          corporateID: props?.bookedDriver[0]?.shiftStartedInCorporateID,
        }),
        redirect: "follow",
      };
      // console.log(requestOptions.body);
    } else if (isRequestSentToDriver === "yes") {
      // url = "/map/service/ride/" + requestTripId + "/status";
      url = "/privatebookingstatus";
      myHeaders = {
        "Content-Type": "application/json",
        // Authorization: "Bearer " + authToken,
      };
      requestOptions = {
        // method: "GET",
        method: "POST",

        headers: myHeaders,
        body: JSON.stringify({
          data: { TripID: requestTripId },
        }),
        redirect: "follow",
      };
    }
  }

  const riderList = (data) => {
    // console.log(data.RidersList);
    data?.corporateRiders?.push({
      mobileNumber: "",
      riderName: "Guest",
    });
    let key = props.bookedDriver[0].shiftStartedInCorporateID;
    if (!sessionStorage.getItem("corporateRiderList"))
      sessionStorage.setItem("corporateRiderList", JSON.stringify({}));
    let temp = JSON.parse(sessionStorage.getItem("corporateRiderList"));
    temp[key] = data.corporateRiders;
    sessionStorage.setItem("corporateRiderList", JSON.stringify(temp));
    setRiderData(data.corporateRiders);
  };

  const { isLoading, sendRequest } = useHttp();

  // Function to get address from lat/lng using reverse geocoding
  const getAddressFromLatLng = (lat, lng) => {
    return new Promise((resolve, reject) => {
      if (!window.google || !window.google.maps) {
        reject("Google Maps not loaded");
        return;
      }
      
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode(
        { location: { lat: parseFloat(lat), lng: parseFloat(lng) } },
        (results, status) => {
          if (status === "OK" && results && results[0]) {
            resolve(results[0].formatted_address);
          } else {
            reject("Geocoding failed: " + status);
          }
        }
      );
    });
  };

  // Fetch driver location and set pickup address
  useEffect(() => {
    if (props.bookedDriver && props.bookedDriver[0]?.driverEmail) {
      sendRequest(
        {
          url: "/driver",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            data: {
              driverEmailID: props.bookedDriver[0].driverEmail,
            },
          },
        },
        (data) => {
          // Access LastLL from driver object in the response
          const lastLL = data?.driver?.LastLL || data?.LastLL;
          
          if (lastLL) {
            const [lat, lng] = lastLL.split(",").map(Number);
            if (!isNaN(lat) && !isNaN(lng)) {
              // Wait for Google Maps to be loaded
              const checkGoogleMaps = setInterval(() => {
                if (window.google && window.google.maps) {
                  clearInterval(checkGoogleMaps);
                  
                  getAddressFromLatLng(lat, lng)
                    .then((address) => {
                      // Set the address in the input field immediately
                      if (pickupInputRef.current) {
                        pickupInputRef.current.value = address;
                        
                        // Update pickupDrop array with the address and lat/lng
                        pickupDrop[0] = {
                          address: address,
                          latLng: `${lat},${lng}`,
                        };
                        
                        // Wait for autocomplete to be initialized (after initMap is called)
                        const waitForAutocomplete = setInterval(() => {
                          if (autocomplete && autocomplete[0]) {
                            clearInterval(waitForAutocomplete);
                            
                            // Create a LatLng object
                            const latLngObj = new window.google.maps.LatLng(lat, lng);
                            
                            // Create a place object that matches Google Places format
                            const place = {
                              formatted_address: address,
                              geometry: {
                                location: latLngObj,
                              },
                              name: address,
                            };
                            
                            // Try to set the place in autocomplete
                            try {
                              // Use the autocomplete's internal method to set place
                              if (autocomplete[0].setPlace) {
                                autocomplete[0].setPlace(place);
                              }
                            } catch (e) {
                              // If setting place fails, the input value is already set
                              console.log("Autocomplete place setting:", e);
                            }
                            
                            // Trigger change handler to clear any errors and update state
                            if (pickupStopChangeHandler) {
                              pickupStopChangeHandler();
                            }
                          }
                        }, 100);
                        
                        // Clear wait interval after 5 seconds
                        setTimeout(() => clearInterval(waitForAutocomplete), 5000);
                      }
                    })
                    .catch((error) => {
                      console.error("Error getting address:", error);
                    });
                }
              }, 100);
              
              // Clear interval after 10 seconds if Google Maps doesn't load
              setTimeout(() => clearInterval(checkGoogleMaps), 10000);
            }
          }
        }
      );
    }
  }, [props.bookedDriver, sendRequest]);

  useEffect(() => {
    if (
      sessionStorage.getItem("corporateRiderList") &&
      JSON.parse(sessionStorage.getItem("corporateRiderList"))[
        props.bookedDriver[0].shiftStartedInCorporateID
      ]
    ) {
      setRiderData(
        JSON.parse(sessionStorage.getItem("corporateRiderList"))[
          props.bookedDriver[0].shiftStartedInCorporateID
        ]
      );
    } else
      sendRequest(
        {
          // url: "/api/v1/DriverList/GetPrivateDriverList",
          url: "/corporateriders",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
            // roleID: "2",
            // roleID: localStorage.getItem("roleId")=="1" ? 1 : 2,
            data: {
              filter: {
                corporateID: props.bookedDriver[0].shiftStartedInCorporateID,
              },
            },
            // isRider: "1",
            // isDriver: "0",
          },
        },
        riderList
      );
  }, [sendRequest]);

  useEffect(() => {
    if (isDriverBookingClicked) {
      move();
      paraMeters();

      fetch(baseURL + url, requestOptions)
        .then(async (response) => {
          let result;
          try {
            result = await response.json();
          } catch (e) {
            // If response is not JSON, try to get text
            const text = await response.text();
            try {
              result = JSON.parse(text);
            } catch (parseError) {
              result = { message: text || "Unknown error occurred" };
            }
          }

          // Check if booking was successful even if there's a notification error
          // The bookingID indicates the booking was created successfully
          // Even if notification fails (status 500), booking can still succeed
          const bookingID = result.data?.bookingID || result.bookingID || result.data?.tripID || result.tripID;
          
          if (bookingID) {
            requestTripId = bookingID; // Set the Trip ID
            setIsRequestSentToDriver("yes");
            setIsDriverBookingClicked(false);
            setIsDataLoading(true);
            const progressBarText = document.getElementById("progressBarText");
            if (progressBarText) {
              progressBarText.innerText = "Sending Trip Request ...";
            }
            // Show a warning if notification failed but booking succeeded
            if ((!response.ok || result.status === 500) && result.message) {
              toast.warning("Booking created successfully. Driver notification may have failed.", {
                position: "top-right",
                autoClose: 4000,
              });
            }
            return;
          }

          // If no bookingID and response is not ok, show error
          if (!response.ok || result.status === 500) {
            // Check if it's a notification/device token error
            const isNotificationError = result.message?.toLowerCase().includes("notification") || 
                                       result.message?.toLowerCase().includes("messaging") ||
                                       result.message?.toLowerCase().includes("entity was not found") ||
                                       result.message?.toLowerCase().includes("registration-token");
            
            if (isNotificationError) {
              // This is a device token/notification error
              // The booking might have been created but we can't proceed without bookingID
              toast.error("Driver device is not registered. Please contact support or try again later.", {
                position: "top-right",
                autoClose: 6000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
              setIsDriverBookingClicked(false);
              setIsDataLoading(false);
              return;
            }
            
            // Show the error message using Toastify
            toast.error(result.message || "Error in booking process. Please try again.", {
              position: "top-right",
              autoClose: 5000, // Time in ms
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });

            // Reset the flags and stop execution
            setIsDriverBookingClicked(false);
            setIsDataLoading(false);
            return;
          }

          // If response is ok but no bookingID, still proceed (might be a warning)
          setIsDriverBookingClicked(false);
          setIsDataLoading(true);
          const progressBarText = document.getElementById("progressBarText");
          if (progressBarText) {
            progressBarText.innerText = "Sending Trip Request ...";
          }
        })
        .catch((error) => {
          console.error("Error during fetch:", error);
          const progressBarText = document.getElementById("progressBarText");
          if (progressBarText) {
            progressBarText.innerText = "An unexpected error occurred.";
          }
          setIsDriverBookingClicked(false);
          setIsDataLoading(false);
        });
    } else if (isRequestSentToDriver === "yes") {
      let pollingAttempts = 0; // Track the number of API calls made

      // Polling for trip status
      const pollingInterval = setInterval(() => {
        if (pollingAttempts >= 1) {
          clearInterval(pollingInterval);
          setTripRequestStatus("fail");
          setIsDataLoading(false);
          const progressBarText = document.getElementById("progressBarText");
          if (progressBarText) {
            progressBarText.innerText = "Driver is not responding.";
          }
          return;
        }

        paraMeters();
        fetch(baseURL + url, requestOptions)
          .then(async (response) => {
            const result = await response.json();

            if (!response.ok) {
              console.error(
                `Polling Error: ${result.message || "Failed to get status"}`
              );
              pollingAttempts++; // Increment attempts in case of error
              return;
            }

            let tripStatus = result?.data;

            clearInterval(pollingInterval); // Stop polling once status changes
            setTripRequestStatus(tripStatus);
            // document.getElementById("progressBarText").innerText =
            //   "Driver rejected the request.";
            setIsDataLoading(false);
          })
          .catch((error) => {
            console.error("Polling Error:", error);
            pollingAttempts++;
            if (pollingAttempts >= 1) {
              clearInterval(pollingInterval);
              setTripRequestStatus("failed");
              setIsDataLoading(false);
              const progressBarText = document.getElementById("progressBarText");
              if (progressBarText) {
                progressBarText.innerText = "Driver is not responding.";
              }
            }
          });
      }, 30000); // Check status every 10 seconds
    }
  }, [isDriverBookingClicked, isRequestSentToDriver]);

  useEffect(() => {
    // if (addStopCount < 2) {
    const script = document.createElement("script");
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyDHdkmGjsfNqasFs6m9CooShFZsqWHcdUs&callback=initMap&libraries=places&v=weekly";
    script.async = true;
    document.body.appendChild(script);
    // }
    let elements = document.getElementsByClassName("removedropInput");
    for (let i = 0; i < elements.length; i++) {
      elements[i].addEventListener("click", removeDropoffs, false);
    }
    return () => {
      for (let i = 0; i < elements.length; i++) {
        elements[i].removeEventListener("click", removeDropoffs);
      }
    };
  }, [isRender]);

  function initMap() {
    // var input1 = document.getElementById("pac-input1");
    // var input2 = document.getElementById("pac-input2");
    // autocomplete[0] = new window.google.maps.places.Autocomplete(input1, {});
    // autocomplete[1] = new window.google.maps.places.Autocomplete(input2);
    for (
      let i = 0;
      i < document.getElementsByClassName("pacInput").length;
      i++
    ) {
      autocomplete[i] = new window.google.maps.places.Autocomplete(
        document.getElementsByClassName("pacInput")[i],
        {
          componentRestrictions: { country: ["in"] },
        }
      );
    }
    for (
      let i = 0;
      i < document.getElementsByClassName("dropoffInput").length;
      i++
    ) {
      autocomplete[i + 2] = new window.google.maps.places.Autocomplete(
        document.getElementsByClassName("dropoffInput")[i],
        {
          componentRestrictions: { country: ["in"] },
        }
      );
    }
  }
  window.initMap = initMap;

  const tripBookClicked = () => {
    if (
      riderInputSearchRef.current.value &&
      pickupInputRef.current.value &&
      dropInputRef.current.value &&
      !error.riderName &&
      (riderInputSearchRef.current.value?.toLowerCase() === "guest"
        ? guestNameInputRef.current.value &&
          guestMoNumberInputRef.current.value.toString().length === 10
        : 1)
    ) {
      if (riderInputSearchRef.current.value?.toLowerCase() === "guest") {
        riderInfo.name = guestNameInputRef.current.value;
        riderInfo.mobileNumber = "91" + guestMoNumberInputRef.current.value;
      }
      // debugger;
      if (!dropOffs[0]?.order) {
        for (let i = 0; i < 2; i++) {
          if (autocomplete[i]?.getPlace()?.geometry?.location?.lat()) {
            pickupDrop[i] = {
              address: document.getElementsByClassName("pacInput")[i].value,
              latLng:
                autocomplete[i]?.getPlace().geometry.location?.lat() +
                "," +
                autocomplete[i]?.getPlace().geometry.location?.lng(),
            };
          }
        }
        for (let i = 2; i < autocomplete.length; i++) {
          if (autocomplete[i]?.getPlace()?.geometry?.location?.lat()) {
            dropOffs[i - 2] = {
              address:
                document.getElementsByClassName("dropoffInput")[i - 2].value,
              latLng:
                autocomplete[i]?.getPlace().geometry.location?.lat() +
                "," +
                autocomplete[i]?.getPlace().geometry.location?.lng(),
            };
          }
        }
        let addStops = [];
        if (dropOffs.length > 0) {
          addStops.push({
            order: 1,
            contactMobileNumber: "",
            contactName: "",
            notes: "",
            latlng: pickupDrop[1]?.latLng,
            address: pickupDrop[1]?.address,
          });
          pickupDrop[1] = {
            latLng: dropOffs[dropOffs.length - 1]?.latLng,
            address: dropOffs[dropOffs.length - 1]?.address,
          };
        }
        for (let i = 0; i < dropOffs.length; i++) {
          addStops.push({
            order: i + 2,
            contactMobileNumber: "",
            contactName: "",
            notes: "",
            latlng: dropOffs[i]?.latLng,
            address: dropOffs[i]?.address,
          });
        }
        dropOffs = addStops;
      }

      error.riderName = "";
      error.pickupStop = "";
      error.dropStop = "";
      error.guestName = "";
      error.guestMoNumber = "";
      setIsFieldError((prev) => !prev);
      setIsDataLoading(true);
      setIsDriverBookingClicked(true);
    } else {
      setIsFieldError((prev) => !prev);
      if (riderInputSearchRef.current.value?.toLowerCase() === "guest") {
        !guestNameInputRef.current.value &&
          (error.guestName = "Please add guest name");
        !(guestMoNumberInputRef.current.value.toString().length === 10) &&
          (error.guestMoNumber = "Please enter valid mobile number");
      }
      !riderInputSearchRef.current.value &&
        (error.riderName = "Please add one rider");
      !pickupInputRef.current.value &&
        (error.pickupStop = "Please add pickup stop");
      !dropInputRef.current.value && (error.dropStop = "Please add drop stop");
    }
  };
  const riderSearchHandler = () => {
    if (riderInputSearchRef.current.value) {
      error.riderName = "";
      setIsSearchedRidersData(
        riderData?.filter(
          (data) =>
            data?.riderName
              ?.toLowerCase()
              .includes(riderInputSearchRef.current.value?.toLowerCase()) ||
            data?.mobileNumber
              ?.toLowerCase()
              .includes(riderInputSearchRef.current.value?.toLowerCase())
        )
      );
    } else {
      error.riderName = "Please add one rider";
      setIsSearchedRidersData(false);
    }
    for (let i = 0; i < riderData?.length; i++) {
      if (
        riderData[i].riderName
          ?.toLowerCase()
          .includes(riderInputSearchRef.current.value?.toLowerCase())
      )
        break;
      if (i === riderData.length - 1) {
        error.riderName =
          riderInputSearchRef.current.value + " is not registred";
        setIsFieldError((prev) => !prev);
      }
    }
  };

  const riderSelectedHandler = (riderName, riderNumber) => {
    riderInfo.name = riderName;
    riderInfo.mobileNumber = riderNumber;
    riderInputSearchRef.current.value =
      riderName + (riderNumber ? "  ( " + riderNumber + " )" : "");
    setIsSearchedRidersData(false);
  };

  if (isRequestSentToDriver === "no") {
    setTimeout(() => {
      setIsRequestSentToDriver(false);
    }, 5000);
  }

  const pickupStopChangeHandler = () => {
    if (pickupInputRef.current.value) {
      error.pickupStop = "";
      setIsFieldError((prev) => !prev);
    } else {
      error.pickupStop = "Please add pickup stop";
      setIsFieldError((prev) => !prev);
    }
  };

  const dropStopChangeHandler = () => {
    if (dropInputRef.current.value) {
      error.dropStop = "";
      setIsFieldError((prev) => !prev);
    } else {
      error.dropStop = "Please add drop stop";
      setIsFieldError((prev) => !prev);
    }
  };

  const guestNameChangeHandler = () => {
    if (guestNameInputRef.current.value) {
      error.guestName = "";
      setIsFieldError((prev) => !prev);
    } else {
      error.guestName = "Please add guest name";
      setIsFieldError((prev) => !prev);
    }
  };

  const guestMoNumberChangeHandler = () => {
    if (guestMoNumberInputRef.current.value.toString().length === 10) {
      error.guestMoNumber = "";
      setIsFieldError((prev) => !prev);
    }
    // else {
    //   error.guestMoNumber = "Please enter valid mobile number";
    //   setIsFieldError(prev => !prev);
    // }
  };

  const addStopClickHandler = () => {
    for (
      let i = 0;
      i < document.getElementById("addStopDiv").children.length;
      i++
    ) {
      if (
        !document.getElementById("addStopDiv").children[i].style.display ||
        document.getElementById("addStopDiv").children[i].style.display ===
          "none"
      ) {
        document.getElementById("addStopDiv").children[i].style.display =
          "flex";
        document.getElementById("addStopIconDiv").children[i].style.display =
          "flex";
        break;
      }
    }
    for (let i = 0; i < 2; i++) {
      if (autocomplete[i]?.getPlace()?.geometry?.location?.lat()) {
        pickupDrop[i] = {
          address: document.getElementsByClassName("pacInput")[i].value,
          latLng:
            autocomplete[i]?.getPlace().geometry.location?.lat() +
            "," +
            autocomplete[i]?.getPlace().geometry.location?.lng(),
        };
      }
    }
    for (let i = 2; i < autocomplete.length; i++) {
      if (autocomplete[i]?.getPlace()?.geometry?.location?.lat()) {
        dropOffs[i - 2] = {
          address: document.getElementsByClassName("dropoffInput")[i - 2].value,
          latLng:
            autocomplete[i].getPlace().geometry.location.lat() +
            "," +
            autocomplete[i].getPlace().geometry.location.lng(),
        };
      }
    }
    let i = 0;
    while (document.getElementsByClassName("dropoffInput")[i].value) i++;
    dropOffs.length = i;
  };

  const removeDropoffs = (e) => {
    for (let i = 0; i < 2; i++) {
      if (autocomplete[i]?.getPlace()?.geometry?.location?.lat()) {
        pickupDrop[i] = {
          address: document.getElementsByClassName("pacInput")[i].value,
          latLng:
            autocomplete[i].getPlace().geometry.location.lat() +
            "," +
            autocomplete[i].getPlace().geometry.location.lng(),
        };
      }
    }
    for (let i = 2; i < autocomplete.length; i++) {
      if (autocomplete[i]?.getPlace()?.geometry?.location?.lat()) {
        dropOffs[i - 2] = {
          address: document.getElementsByClassName("dropoffInput")[i - 2].value,
          latLng:
            autocomplete[i].getPlace().geometry.location.lat() +
            "," +
            autocomplete[i].getPlace().geometry.location.lng(),
        };
      }
    }
    for (
      let i = 0;
      i < document.getElementsByClassName("dropoffInput").length;
      i++
    ) {
      if (
        e.target.parentElement.children[0].value ===
        document.getElementById("addStopDiv").children[i].children[0].value
      ) {
        autocomplete.splice(i + 2, 1);
        document.getElementById("addStopDiv").children[i].style.display =
          "none";
        document.getElementById("addStopIconDiv").children[i].style.display =
          "none";
        document.getElementById("addStopDiv").children[i].children[0].value =
          "";
        document
          .getElementById("addStopDiv")
          .insertBefore(
            document.getElementById("addStopDiv").children[i],
            document.getElementById("addStopDiv").children[
              document.getElementById("addStopDiv").children
            ]
          );
        document
          .getElementById("addStopIconDiv")
          .insertBefore(
            document.getElementById("addStopIconDiv").children[i],
            document.getElementById("addStopIconDiv").children[
              document.getElementById("addStopIconDiv").children
            ]
          );
        dropOffs.splice(i, 1);
        break;
      }
    }
    let i = 0;
    while (document.getElementsByClassName("dropoffInput")[i].value) i++;
    dropOffs.length = i;
    setIsRender((prev) => !prev);
  };

  function move(j = 0, time = 20) {}

  return (
    // <React.Fragment>
    //   {isLoading && (
    //     <Backdrop
    //       sx={{
    //         color: "rgba(34, 137, 203, 255)",
    //         zIndex: (theme) => theme.zIndex.drawer + 1,
    //       }}
    //       open={isLoading}
    //     >
    //       <CircularProgress color="inherit" />
    //     </Backdrop>
    //   )}
    //   <div className="driverBooking-container">
    //     <header>
    //       <div className="driverInfo">
    //         <img src={props.bookedDriver[0].driverImage}></img>
    //         <div className="driverDetailsInfo">
    //           <div>{props.bookedDriver[0].driverName}</div>
    //           <div style={{ fontSize: "12px" }}>
    //             {props.bookedDriver[0].carNumber}
    //           </div>
    //         </div>
    //       </div>
    //       <div className="carInfo">

    //         <div>{props.bookedDriver[0].carModel?.toLowerCase()}</div>
    //         <div style={{ fontSize: "12px" }}>
    //           {props.bookedDriver[0].carColor?.toLowerCase()}
    //         </div>
    //       </div>
    //     </header>
    //     {tripRequestStatus && (
    //       <div className="success-sub-container" style={{ top: "65%" }}>
    //         <div className="success-msg">
    //           <img
    //             src={tripRequestStatus >= 2 ? TickmarkImage : ErrorImage}
    //             alt={error}
    //           />
    //           <p className="data-save">
    //             {tripRequestStatus >= 2
    //               ? "Driver has accepted the request"
    //               : tripRequestStatus === -1
    //               ? "Driver has rejected the request"
    //               : "Driver is not responding"}
    //           </p>
    //         </div>
    //         <div
    //           style={{
    //             display: "flex",
    //             alignItems: "center",
    //             justifyContent: "center",
    //             marginTop: "10px",
    //           }}
    //         >
    //           <button

    //             style={{ backgroundColor: littleGreen, color: "white" }}
    //             onClick={() => window.location.reload()}
    //           >
    //             OK
    //           </button>
    //         </div>
    //       </div>
    //     )}
    //     {!tripRequestStatus && (
    //       <React.Fragment>
    //         <main>
    //           {isDataLoading && (
    //             <React.Fragment>
    //               <div class="wrapper">
    //                 <div class="progressbar">

    //                 </div>
    //                 <span
    //                   id="progressBarText"
    //                   style={{
    //                     display: "inline-block",
    //                     zIndex: "999",
    //                     width: "100%",
    //                     textAlign: "center",
    //                   }}
    //                 >
    //                   Connecting to driver ...
    //                 </span>
    //                 <br />
    //               </div>
    //             </React.Fragment>
    //           )}
    //           {isRequestSentToDriver === "no" && (
    //             <div className="tripRequestError">
    //               {"Driver is unreachable. Please try again after some time"}
    //             </div>
    //           )}
    //           <div
    //             style={{ display: "flex", gap: "10px", alignItems: "center" }}
    //           >
    //             <img src={building} style={{ width: "20px", height: "20px" }} />
    //             <input
    //               type="text"
    //               disabled
    //               value={props.bookedDriver[0].activeShiftCororateName}
    //               className="tags"
    //             />
    //           </div>
    //           <div
    //             style={{ display: "flex", gap: "10px", alignItems: "center" }}
    //           >
    //             <img src={user} style={{ width: "20px", height: "20px" }} />
    //             <div style={{ width: "100%" }}>
    //               <input
    //                 type="text"
    //                 placeholder="Please add any one rider"
    //                 className="tags"
    //                 ref={riderInputSearchRef}
    //                 onChange={riderSearchHandler}
    //               ></input>
    //               {error.riderName && (
    //                 <p className="errorField">{error.riderName}</p>
    //               )}
    //               {searchedRidersData && (
    //                 <div className="searchedRiders">
    //                   {searchedRidersData.map((data) => (
    //                     <p
    //                       onClick={(e) =>
    //                         riderSelectedHandler(
    //                           data.riderName,
    //                           data?.mobileNumber
    //                         )
    //                       }
    //                     >
    //                       {data.riderName +
    //                         (data?.mobileNumber
    //                           ? "  ( " + data.mobileNumber + " )"
    //                           : "")}
    //                     </p>
    //                   ))}
    //                 </div>
    //               )}
    //             </div>
    //           </div>
    //           {riderInputSearchRef?.current?.value?.toLowerCase() ===
    //             "guest" && (
    //             <div
    //               style={{
    //                 display: "flex",
    //                 justifyContent: "end",
    //                 gap: "20px",
    //               }}
    //             >
    //               <div style={{ width: "45%", display: "inline-block" }}>
    //                 <input
    //                   type="text"
    //                   ref={guestNameInputRef}
    //                   onChange={guestNameChangeHandler}
    //                   placeholder="Name of the Guest"
    //                   className="tags"
    //                 />
    //                 {error.guestName && (
    //                   <p className="errorField">{error.guestName}</p>
    //                 )}
    //               </div>
    //               <div style={{ width: "45%", display: "inline-block" }}>
    //                 <input
    //                   type="text"
    //                   ref={guestMoNumberInputRef}
    //                   onChange={guestMoNumberChangeHandler}
    //                   placeholder="Mobile Number of the Guest"
    //                   className="tags"
    //                 />
    //                 {error.guestMoNumber && (
    //                   <p className="errorField">{error.guestMoNumber}</p>
    //                 )}
    //               </div>
    //             </div>
    //           )}
    //           <div
    //             style={{
    //               display: "flex",
    //               gap: "10px",
    //               alignItems: "center",
    //               justifyContent: "space-between",
    //             }}
    //           >
    //             <div
    //               style={{
    //                 display: "flex",
    //                 flexDirection: "column",
    //                 justifyContent: "space-between",
    //                 alignItems: "center",
    //               }}
    //             >
    //               <img
    //                 src={pickupicon}
    //                 style={{ width: "20px", height: "20px" }}
    //               />
    //               <img
    //                 src={threedots}
    //                 style={{ width: "20px", height: "20px" }}
    //               />
    //               <div id="addStopIconDiv">
    //                 {arr.map(() => (
    //                   <div className="addStopIconSubDiv">
    //                     <img
    //                       src={startLocation}
    //                       style={{ width: "20px", height: "20px" }}
    //                     />
    //                     <img
    //                       src={threedots}
    //                       style={{ width: "20px", height: "20px" }}
    //                     />
    //                   </div>
    //                 ))}
    //               </div>
    //               <img
    //                 src={dropicon}
    //                 style={{ width: "20px", height: "20px" }}
    //               />
    //             </div>
    //             <div
    //               style={{
    //                 display: "flex",
    //                 flexDirection: "column",
    //                 width: "100%",
    //               }}
    //             >
    //               <input
    //                 type="text"
    //                 id="pac-input1"
    //                 placeholder="Pickup Address"
    //                 className="tags pacInput"
    //                 ref={pickupInputRef}
    //                 onChange={pickupStopChangeHandler}
    //               />
    //               {error.pickupStop && (
    //                 <p className="errorField">{error.pickupStop}</p>
    //               )}
    //               <input
    //                 type="text"
    //                 id="pac-input2"
    //                 placeholder="Dropoff Address"
    //                 className="tags pacInput"
    //                 ref={dropInputRef}
    //                 onChange={dropStopChangeHandler}
    //               />
    //               {error.dropStop && (
    //                 <p className="errorField">{error.dropStop}</p>
    //               )}
    //               <div id="addStopDiv">
    //                 {arr.map(() => (
    //                   <div className="addStopSubDiv">
    //                     <input
    //                       type="text"
    //                       className="tags dropoffInput"
    //                       placeholder="Add Stop"
    //                     />
    //                     <span className="removedropInput">X</span>
    //                   </div>
    //                 ))}
    //               </div>

    //             </div>
    //           </div>
    //           <div
    //             onClick={addStopClickHandler}
    //             style={{
    //               display: "flex",
    //               alignItems: "center",
    //               gap: "10px",
    //               cursor: "pointer",
    //               marginTop: "5px",
    //             }}
    //           >
    //             <img
    //               src={addStopIcon}
    //               style={{ width: "20px", height: "20px" }}
    //             />
    //             <p
    //               style={{ color: "rgba(34, 137, 203, 255)", fontSize: "14px" }}
    //             >
    //               Add Stop
    //             </p>
    //           </div>

    //         </main>
    //         <footer>
    //           <button onClick={() => props.setBookedDriver(false)}>
    //             Cancel
    //           </button>
    //           <button disabled={isDataLoading} onClick={tripBookClicked}>
    //             Book Now
    //           </button>
    //         </footer>
    //       </React.Fragment>
    //     )}
    //   </div>
    // </React.Fragment>

    <React.Fragment>
      {isLoading && (
        <Backdrop
          sx={{
            color: "rgba(34, 137, 203, 255)",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <div className="driverBooking-container">
        <header>
          <div className="driverInfo">
            <img src={props.bookedDriver[0].driverImage} alt="Driver" />
            <div className="driverDetailsInfo">
              <div>{props.bookedDriver[0].driverName}</div>
              <div className="carNumber">{props.bookedDriver[0].carNumber}</div>
            </div>
          </div>
          <div className="carInfo">
            <div>{props.bookedDriver[0].carModel}</div>
            <div className="carColor">
              {props.bookedDriver[0].shiftCarColor?.toLowerCase()}
            </div>
          </div>
        </header>
        {tripRequestStatus && (
          <div className="success-sub-container">
            <div className="success-msg">
              <img
                src={tripRequestStatus >= 2 ? TickmarkImage : ErrorImage}
                alt={error}
              />
              <p className="data-save">
                {tripRequestStatus >= 2
                  ? "Driver has accepted the request"
                  : tripRequestStatus === -1
                  ? "Driver has rejected the request"
                  : "Driver is not responding"}
              </p>
            </div>
            <div className="success-button-container">
              <button
                className="success-button"
                onClick={() => window.location.reload()}
              >
                OK
              </button>
            </div>
          </div>
        )}
        {!tripRequestStatus && (
          <React.Fragment>
            <main>
              {isDataLoading && (
                <React.Fragment>
                  <div className="wrapper">
                    <div className="progressbar"></div>
                    <span id="progressBarText" className="progressBarText">
                      Connecting to driver ...
                    </span>
                    <br />
                  </div>
                </React.Fragment>
              )}
              {isRequestSentToDriver === "no" && (
                <div className="tripRequestError">
                  {"Driver is unreachable. Please try again after some time"}
                </div>
              )}
              <div className="input-container">
                <img src={building} className="input-icon" />
                <input
                  type="text"
                  disabled
                  // value={props.bookedDriver[0].activeShiftCororateName}
                  value={props.bookedDriver[0].shiftStartedInCorporateName}
                  className="tags"
                />
              </div>
              <div className="input-container">
                <img src={user} className="input-icon" />
                <div className="rider-input-wrapper">
                  <input
                    type="text"
                    placeholder="Please add any one rider"
                    className="tags"
                    ref={riderInputSearchRef}
                    onChange={riderSearchHandler}
                  />
                  {error.riderName && (
                    <p className="errorField">{error.riderName}</p>
                  )}
                  {searchedRidersData && (
                    <div className="searchedRiders">
                      {searchedRidersData.map((data) => (
                        <p
                          onClick={(e) =>
                            riderSelectedHandler(
                              data.riderName,
                              data?.mobileNumber
                            )
                          }
                        >
                          {data.riderName +
                            (data?.mobileNumber
                              ? "  ( " + data.mobileNumber + " )"
                              : "")}
                        </p>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              {riderInputSearchRef?.current?.value?.toLowerCase() ===
                "guest" && (
                <div className="guest-input-container">
                  <div className="guest-input-wrapper">
                    <input
                      type="text"
                      ref={guestNameInputRef}
                      onChange={guestNameChangeHandler}
                      placeholder="Name of the Guest"
                      className="tags"
                    />
                    {error.guestName && (
                      <p className="errorField">{error.guestName}</p>
                    )}
                  </div>
                  <div className="guest-input-wrapper">
                    <input
                      type="text"
                      ref={guestMoNumberInputRef}
                      onChange={guestMoNumberChangeHandler}
                      placeholder="Mobile Number of the Guest"
                      className="tags"
                    />
                    {error.guestMoNumber && (
                      <p className="errorField">{error.guestMoNumber}</p>
                    )}
                  </div>
                </div>
              )}
              <div className="location-input-container">
                <div className="location-icons">
                  <img src={pickupicon} className="location-icon" />
                  <img src={threedots} className="dots-icon" />
                  <div id="addStopIconDiv">
                    {arr.map(() => (
                      <div className="addStopIconSubDiv">
                        <img src={startLocation} className="location-icon" />
                        <img src={threedots} className="dots-icon" />
                      </div>
                    ))}
                  </div>
                  <img src={dropicon} className="location-icon" />
                </div>
                <div className="location-inputs">
                  <input
                    type="text"
                    id="pac-input1"
                    placeholder="Pickup Address"
                    className="tags pacInput"
                    ref={pickupInputRef}
                    onChange={pickupStopChangeHandler}
                  />
                  {error.pickupStop && (
                    <p className="errorField">{error.pickupStop}</p>
                  )}
                  <input
                    type="text"
                    id="pac-input2"
                    placeholder="Dropoff Address"
                    className="tags pacInput"
                    ref={dropInputRef}
                    onChange={dropStopChangeHandler}
                  />
                  {error.dropStop && (
                    <p className="errorField">{error.dropStop}</p>
                  )}
                  <div id="addStopDiv">
                    {arr.map(() => (
                      <div className="addStopSubDiv">
                        <input
                          type="text"
                          className="tags dropoffInput"
                          placeholder="Add Stop"
                        />
                        <span className="removedropInput">X</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="add-stop-container" onClick={addStopClickHandler}>
                <img src={addStopIcon} className="add-stop-icon" />
                <p className="add-stop-text">Add Stop</p>
              </div>
            </main>
            <footer>
              <button
                className="cancel-button"
                onClick={() => props.setBookedDriver(false)}
              >
                Cancel
              </button>
              <button
                className="book-button"
                disabled={isDataLoading}
                onClick={tripBookClicked}
              >
                Book Now
              </button>
            </footer>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};

export default PrivateDriverBooking;
